<template>
    <span>
        <span v-if="player.isFriend === true">
            <i class="fas fa-heart darkred" :title="$t('site.status.isFriendTip')"></i>
        </span>
        <span v-if="player.isActive === false">
            <i class="fas fa-exclamation-triangle" :title="$t('site.status.inactiveWarningTip', [player.lastScoreChange])"></i>
        </span>
    </span>
</template>


<script>
    export default {
        name: 'elv-user-badges',
        props: {
            'player' : {required:true}
        },
        data () {
            return {
            }
        },
    }
</script>

<style scoped>
    .darkred {
        color: darkred;
    }
</style>


// WEBPACK FOOTER //
// src/components/ElvUserBadges.vue